/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*************************************!*\
  !*** ./public/js/pages/pageCart.js ***!
  \*************************************/
/* 24/10/2026 (B37): las llamadas al carrito usan Shopify.routes.root para funcionar dentro de /es-co, /es-mx, etc. */
document.addEventListener("DOMContentLoaded", function () {
  var cartPage = document.getElementById("cartPage");
  if (cartPage) {
    // Actualizar cantidad
    var updateQuantity = function updateQuantity(itemId, action) {
      var quantityInput = document.querySelector(".cart-item[data-item-id=\"".concat(itemId, "\"] .cart-item__quantity-input"));
      var quantity = parseInt(quantityInput.value);
      if (action === "increase") {
        quantity += 1;
      } else if (action === "decrease" && quantity > 1) {
        quantity -= 1;
      }
      fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||"/")+"cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: itemId,
          quantity: quantity
        })
      }).then(function (response) {
        return response.json();
      }).then(function () {
        window.location.reload(); // Recargar para actualizar el carrito
      })["catch"](function (error) {
        return console.error("Error:", error);
      });
    }; // Eliminar producto
    var removeItem = function removeItem(itemId) {
      fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||"/")+"cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: itemId,
          quantity: 0
        })
      }).then(function (response) {
        return response.json();
      }).then(function () {
        window.location.reload(); // Recargar para actualizar el carrito
      })["catch"](function (error) {
        return console.error("Error:", error);
      });
    };
    // Delegación de eventos para botones de cantidad y eliminar
    cartPage.addEventListener("click", function (e) {
      var target = e.target;
      var action = target.getAttribute("data-action");
      var item = target.closest(".cart-item");
      var itemId = item ? item.getAttribute("data-item-id") : null;
      if (action === "increase" || action === "decrease") {
        updateQuantity(itemId, action);
      } else if (action === "remove") {
        removeItem(itemId);
      }
    });
  }
});
/******/ })()
;
